import { withTranslation } from "react-i18next";
import { Container, TextWrapper, Content } from "./styles";
import { primaryHeaderColor } from "../../styles";

interface Props {
  title: string;
  content: string;
  t: any;
}

const Block = ({ title, content, t }: Props) => {
  return (
    <Container>
      <h6
        style={{
          fontFamily: "'seasons', 'Motiva Sans Bold', 'serif'",
          fontWeight: "bold",
          color: primaryHeaderColor,
        }}
      >
        {t(title)}
      </h6>
      <TextWrapper>
        <Content>{t(content)}</Content>
      </TextWrapper>
    </Container>
  );
};

export default withTranslation()(Block);
